var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 980 980",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h980v980h-980z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(387,225)",
    d: "m0 0h10l10 3 9 6 6 7 11 20 8 14 6 9 5 10 7 11 6 11 14 24v2l272 1 6 4 4 5 1 2 1 200 17 3 14 4 17 8 15 11 9 8 7 8 6 8 9 14 12 22 5 11 11 25v5l-5 3-9 3v2l-5 3-13 5-8 4-7 3-6 2-9 4-2 4 11 19 6 11 1 5-6 3-21 5-11 3h-5v2l-20 6-8 1-8 3-14 3-9 2-9 3-23 6-10 4-14 1-19-5-6-1h-19l-12 7-6 7-5 4-3 7h-2l-1 4h-506v-6h235v-7l4-4 36-1 1-30h-242l-8-7-2-4-2-52-11-4-8-7-6-12-1-5v-8l3-15 8-42 6-31 8-41 1-6 1-177 5-8 6-4h168l2-6 8-13 9-16 22-38 12-21 7-11 10-9z",
    fill: "#D44B80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(491,359)",
    d: "m0 0h255v71l-4-5-7-7-13-8-21-7-19-3h-9l-15 3-9 5-5 10-7 21v14l6 12 2 3v-8l5 1 6 2h11l-5-5 6 2h13l-5-6 1-2 11 4 13 4 8 4 4 5 4 13 3 12v3h3l2-19h4l3 5 2 23v6h2l2-5 7-15h1v61l17 1 17 3 14 4 17 8 15 11 9 8 7 8 6 8 9 14 12 22 5 11 11 25v5l-5 3-9 3v2l-5 3-13 5-8 4-7 3-6 2-9 4-2 4 11 19 6 11 1 5-6 3-21 5-11 3h-5v2l-20 6-8 1-8 3-14 3-9 2-9 3-23 6-10 4-14 1-19-5-6-1h-19l-12 7-6 7-5 4-3 5h-60l-2-8-3-2-37-1v-31l14-1-9-10-12-16-10-14v-2h-2l-6-10-343-1v-10l4-3 14-4 8-3 9-4 8-2 14-5 11-4 10-3 8-3 7-3 13-4 10-4 8-2 19-7 13-4 7-3 10-3 7-3 13-4 35-12 11-6 4-5 2-3h2l2-9v-14l-7-14-11-9v-2l-4-1-5-5-14-12-11-10v-2l194-1 11-3 8-6 7-8 4-12v-10l-3-10-10-17-3-6-8-14-6-9-6-12-8-13-6-10-5-9-8-14-5-8-3-6z",
    fill: "#8291FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,146)",
    d: "m0 0h48l24 2 35 5 37 8 27 8 23 9 10 5 10 4 10 6 11 6 16 10 10 7v2h3v2l4 2 10 8v2h2v2l4 2 16 16v2h2v2h2l6 8v2h2v3h2l6 9v2h2l5 9 6 11 6 12 9 21 2 5v3l4 2h-246l-13-1-15-26-6-11-11-18-6-11-6-9-5-10-11-19-8-7-9-4-7-1h-8l-13 4-10 9-12 21-22 38-12 20-6 11-8 14h-162v-1h21l1-12 6-22 4-10-3-8-3-6-2-8v-20l3-10 6-11 9-10 11-7 16-5 16-1 3-4h2v-2h2v-2h2v-2l10-8h2v-2l6-4h2v-2h3v-2l13-8 23-11 9-4 13-4 32-7z",
    fill: "#E7EBFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(737,542)",
    d: "m0 0h2l3 6 4 2v3l17 1 17 3 14 4 17 8 15 11 9 8 7 8 6 8 9 14 12 22 5 11 11 25v5l-5 3-9 3v2l-5 3-13 5-8 4-7 3-6 2-9 4-2 4 11 19 6 11 1 5-6 3-21 5-11 3h-5v2l-20 6-8 1-8 3-14 3-9 2-9 3-23 6-10 4-14 1-19-5-6-1h-19l-12 7-6 7-5 4-3 5h-60l-2-8-3-2-37-1v-31h15l7 8 2 1 1 3 6 5 4 2 3 3h2v2l9 1 10-3 1-2 8-6 9-9v-2l4-3h26l-3-38-2-9v-2l-11-7-8-4-16-10v-2l-6-2-4-3-5-3-4 9-6 13-2 1-7-6-7-8-13-13-7-9-8-7v-2l-3-1-4-5v-2h-3l-14-16-2-1-3-5-15-15-8-9v-11l1-15-2-7-6-8-4-5h-2v12h-4l-4-8-3-5v-3h-2l-1 2-1-3h2l-3-6 250-1 8-3 5 9 5 7 6-2 19-10 18-10z",
    fill: "#83D2F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(390,244)",
    d: "m0 0 9 1 8 9 9 16v2h2l6 12 6 10v2h2l7 14 10 17 6 9 6 12 6 10 10 17 6 11 8 14 13 22 12 21 14 24 12 21 1 3v8l-2 5h-2v2l-6 4-8 1h-270l-8-3-5-6-2-7 3-10 7-12 6-10 6-11 9-15 2-5h2l2-6 10-16 6-11 14-25 6-9 4-8 10-17 11-19 13-23 10-17 11-19 7-12 7-5z",
    fill: "#FDFDFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(172,419)",
    d: "m0 0h8l9 6 11 10 7 5 5 5 11 10 8 7 2 4-6 10-4 10-1 5v8l3 10 6 9 8 7 13 4h54l5 2 11 10 11 9 11 10 7 5 5 5 10 9 5 5 2 3v10l-4 6-8 4-40 14-36 12-19 7-36 12-14 5-40 14-23 8-17 6-8 1-7-3-4-5-1-2v-10l15-79 8-41 7-37 5-25 11-56 4-6z",
    fill: "#FDFDFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(136,701)",
    d: "m0 0h5v11h343l6 9v2h2l8 12 10 13 11 14 3 4h-15v31h37l5 5v6h60v2h-2l-1 4h-506v-6h235v-7l4-4 36-1 1-30h-242l-8-7-2-4-1-25v-26l1-2z",
    fill: "#44497A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(124,513)",
    d: "m0 0h1v19l-7 37-8 41-9 47-2 10v8l3 10 6 9 9 6 8 3 2 52 3 5 6 5 242 1v30l-1 1-38 1-2 10h-188l-5-1v-2l-5-1-12-6-7-4v-2l-5-2-3-2v-2l-5-2v-2l-4-2-12-12-8-10-6-9v-3h-2l-8-15-6-16-5-19-2-23v-12l3-20 7-21 6-11 10-18 7-12 1-3h2l2-5 4-8 7-11 5-9 9-15z",
    fill: "#E6EBFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(326,637)",
    d: "m0 0h109l10 16 8 13 2 5 2 1 4 7 7 11 10 14 4 8h-341v-10l4-3 14-4 8-3 9-4 8-2 14-5 11-4 10-3 8-3 7-3 13-4 10-4 8-2 19-7 13-4 7-3 10-3 7-3z",
    fill: "#8291FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,553)",
    d: "m0 0h249v3l-3-1-16 1-10 4-7 1-3 1-1 3-7 3-2 3-5 3-6 7-5 5-5 6-3 7-3 1-2 7-4 5-2 8-8 16-3 8h-3l-3 10-5 12-3 12-3 5 2 1-4 2-4 9-6 13-2 1-7-6-7-8-13-13-7-9-8-7v-2l-3-1-4-5v-2h-3l-14-16-2-1-3-5-15-15-8-9v-11l1-15-2-7-6-8-4-5h-2v12h-4l-4-8-3-5v-3h-2l-1 2-1-3h2z",
    fill: "#8191FA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(881,684)",
    d: "m0 0h5l3 10 3 7 1 7 3 7 2 9 3 9 1 8 2 6 1 9 1 4v12l-1 4-2 7-8 7-9 4-9 2-7 3-13 2-7 2-15 2-3-1v2l-16 1 99 1v6l-232 1-4 1v2h-9l-10-3h-19l-9 6-3 1h-13l-10-2-1-4 2-1 2-5h2l1-5 5-7 4-2 4-5 12-7h19l22 5 3 1 14-1 10-4 31-8 7-2 10-3 14-3 1-1 10-2 14-4h4v-2l31-8 12-3-6-12-13-23 1-3 5-3 7-4 6-2 12-5 11-5 7-3z",
    fill: "#F3A8A2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(419,552)",
    d: "m0 0h6l4 5v3h2l3 7 4 6v3h4l-1-5v-7h4l7 8 4 7 1 11-1 9v11l8 9 17 17v3l4 2 12 13v2h3l5 7 7 6 7 8 5 6 18 18 5 6 3 1 8-16 3-7 15 9v2l5 2 7 5 5 3 7 3 12 8v3l2 8 2 26v12l-26 1-11 12-5 5h-3l-1 3-12 5-7-1-7-4-1-2-5-3-5-4v-3l-4-2-5-5-3-5-10-12-12-16-7-10v-2h-2l-6-10-4-4-6-9-7-10-9-14-9-15-10-16-6-10-5-8v-3h-2l-4-6-5-5-5-4-4-4-4-5-4-14-1-10 1-9 3-3 2-4 5-3 7-2-1-2z",
    fill: "#F3A8A2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,237)",
    d: "m0 0h29l4 3 1 14 18 7 5 1 8-7h6l8 7v2h2l4 4v2h2v2h2l2 4v5l-4 5h-2l-1 3h-2l8 20 1 3 13 1 4 5v23l59 1v1h-246l-1-2v-25l5-5h13l3-11 5-10-2-4-6-7 1-7h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2l5-3 6 2 8 7 16-7 6-1v-12z",
    fill: "#C3D0E8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,343)",
    d: "m0 0h271l6 4 4 5 1 2v201l-14-1-2-1-1-58-9 17h-2l-2-17-1-12-3-5h-2l-1 13-2 6h-3l-5-19-4-11-7-5-10-3-9-3-8-3 4 6 1 2h-14l-4-1 4 4h-12l-11-4 1 9-5-5-5-11v-14l8-24 5-8 9-5 15-3h9l19 3 21 7 14 9 7 7 2 3 1-69h-258l-8-14z",
    fill: "#262940"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,419)",
    d: "m0 0h1l2 6 8 20 8 16 12 23 1 4h2l6 11 7 10 3 3 4 5v2l3 1 5 6v2l4 2v2l4 2v2h2v2h2l7 8 9 10 2 4h2l8 11v2h2l14 22 8 13 8 16 5 13 5 11 7 20 4 12 4 21 1 11v30l-3 19-5 19-5 12-6 14-2 2h-89l4-2h16v-2l13-1 11-2 4-1 13-2 1-2 4-1 2 1 1-2 2 1 1-2 9-3 8-6 3-6v-5l1-1v-12l-1-4-1-9-2-7-2-11v-4l-2-1-4-15-1-3-2-11-2-1-1-8-6-1-7 3-3-1 5-3 8-3-1-8-10-22-10-21-11-19-10-14-12-12-9-8-14-9-15-7-16-4-13-2-1-1z",
    fill: "#E6EBFA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(379,766)",
    d: "m0 0h130v31h37l5 5v6h60v2h-2l-1 4h-506v-6h235v-7l4-4h38z",
    fill: "#262A41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(208,214)",
    d: "m0 0h21l10 3 10 6 9 8 7 10 4 10 1 5v20l-4 12-6 10-8 9-14 8-9 3h-21l-12-4-10-6-8-7-9-14-3-11v-20l3-10 6-11 9-10 11-7z",
    fill: "#D44B80"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(141,359)",
    d: "m0 0h152l-2 6-11 19-7 12-5 9-5 8-1 3h-2l-2 6-5 8-5 10-6 8h-2l-4-5-11-9-4-3v-2l-4-2-11-10-8-7-7-5-11-3h-9l-13 5-7 6-6 12-2 12-2 2z",
    fill: "#8291FB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,452)",
    d: "m0 0 17 5 8 3 8 4 4 5 4 13 3 12v3h3l2-19h4l3 5 2 23v6h2l2-5 7-15h1v58l-5-2-2-6-3 3-23 12-17 9h-3l-5-8-4-7h-4l-9-3-7-4-8-12-6-13-2-18-1-23-2-12v-6l5 1 6 2h11l-5-5 6 2h13l-5-6z",
    fill: "#F3A8A2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(136,701)",
    d: "m0 0h5v11h343l6 9v2h2l2 3v4h-369v-26l1-2z",
    fill: "#262A42"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(390,244)",
    d: "m0 0 9 1 8 9 9 16v2h2l6 12 6 10v2h2l7 14 10 17 6 9 6 12 6 10 10 17 6 11 8 14 13 22 12 21 14 24 12 21 1 3v8l-2 5h-2v2l-6 4-8 1h-270l-8-3-5-6-2-7 3-10 7-12 6-10 6-11 9-15 2-5h2l2-6 10-16 6-11 14-25 6-9 4-8 10-17 11-19 13-23 10-17 11-19 7-12 7-5zm-2 6-7 5-1 4-10 17-1 4h-2l-1 6h-2l-7 13-6 10v2l-2 1-6 11-13 23-10 17-9 15-14 25-1 4h-2l-5 10-12 20-6 11-5 8v3h-2l-5 10-7 11-6 12v6l2 4 4 3 277 1 6-4 3-6-3-10-9-15-8-13-6-12-6-9-4-8-4-6-6-11-10-17-6-11-2-4h-2l-1-4-4-6v-3h-2l-2-5-9-16-5-8-11-19-6-11-7-11-2-4-12-22-8-13-3-5-5-3z",
    fill: "#E7ECFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(136,343)",
    d: "m0 0h168l-6 12-3 4h-154v94l-14 73-2-1v-170l5-8z",
    fill: "#272B42"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(830,408)",
    d: "m0 0h11l10 3 9 6 7 8 4 11v15l-3 9-7 9-9 7-10 3h-13l-11-4-9-7-6-10-3-10v-8l2-9 5-9 5-5 8-6z",
    fill: "#D54D81"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,287)",
    d: "m0 0h12l10 3 10 6 6 6v2h2l5 9 3 7v22h-86v-20l3-10 5-8h2l2-4 4-4h2v-2l11-5z",
    fill: "#E7ECFB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,163)",
    d: "m0 0 5 2v6l6 1h4l1-1h5l6 7-1 5-1 3 3 7 6 1v14l-6 1-4 9h2l1 6-7 7-5-1-4-1-7 2v6l-2 1h-12l-2-7-8-4v2l-5 2-8-7v-5l2-3-2-8-7-1v-13l7-2 2-9-2-4 7-8 4-1 2 2 10-1v-6l1-1z",
    fill: "#C3D2E9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,637)",
    d: "m0 0h98l-1 5-10 24-3 12-3 5 2 1-4 2-4 9-6 13-2 1-7-6-7-8-13-13-7-9-8-7v-2l-3-1-4-5v-2h-3l-14-16-2-2z",
    fill: "#8191FA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(172,419)",
    d: "m0 0h8l9 6 11 10 7 5 5 5 11 10 8 7 2 4-4 2v-2h-2l-5-5-6-5-8-7-4-3v-2l-6-3v-2l-4-2-4-3v-2l-5-2-5-5-4-1-6 2-3 6-9 48-3 13-7 38-4 20-2 11-5 25-9 47-5 26-2 9 1 9 5 2 9-1 34-12 8-3 15-5 11-4 51-17 9-4 13-4 25-9 42-14 19-7 4-3v-10l-12-10v-2l-4-2-8-7-4-3v-2l-5-2-6-5-1-2-3-1v-2h-2v-3l-4-2-6-4v-2l-4-2-4-4 1-3 6 2 11 10 11 9 11 10 7 5 5 5 10 9 5 5 2 3v10l-4 6-8 4-40 14-36 12-19 7-36 12-14 5-40 14-23 8-17 6-8 1-7-3-4-5-1-2v-10l15-79 8-41 7-37 5-25 11-56 4-6z",
    fill: "#E7ECFB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,766)",
    d: "m0 0h15l7 8 2 1 1 3 6 5 4 2 3 3h2v2l9 1 10-3 1-2 8-6 9-9v-2l4-3h26l1 1 2 27 5-2-2 4-8 7-3 5h-60l-2-8-3-2-37-1z",
    fill: "#E6EAF8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,332)",
    d: "m0 0h9l4 2 4 7v22l-2 61-3 5-4 3-9-1-4-4-1-3-2-64v-19l4-6h2v-2z",
    fill: "#D44C81"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(391,591)",
    d: "m0 0h11l4 10 4 6 6 4 4 5 5 5 1 3h2l5 10 2 3-100 1-7-1 3-2 38-13 11-6 4-5 2-3h2l2-9z",
    fill: "#8291FB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(198,493)",
    d: "m0 0 7 1 5 5 15 48 6 19v8l-5 5h-8l-5-5-13-34-7-20-5-13 1-7 2-4z",
    fill: "#D54D81"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,553)",
    d: "m0 0h249v3l-3-1-16 1-10 4h-217l-1 2-1-3h2z",
    fill: "#A3B2FB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(265,405)",
    d: "m0 0 1 3-4 8h-2l-2 6-5 8-5 10-6 8h-2l-4-5-11-9-4-3v-2l-4-2-11-10-8-7-5-4z",
    fill: "#8291FB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,668)",
    d: "m0 0h57l-1 9-4 6 2 1-4 2-4 9-6 13-2 1-7-6-7-8-13-13-7-9-4-4z",
    fill: "#8291FB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(198,240)",
    d: "m0 0 7 6 12 12 4-2 16-16 6 5-2 4-6 7-7 6-2 5 3 3v2l4 2 9 9 1 5-5 4-7-6-12-12-4 2-7 6-1 2h-2l-2 4-3 3-4-1-4-4 6-7 12-12-2-4-16-16z",
    fill: "#F9FAFD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,663)",
    d: "m0 0h2l8 18 6 10 8 16 2 5 5-1 6 12 6 10 6 11 1 5-6 3-21 5-11 3-4-1 9-5h2v-2l5-5 1-2v-11l-10-28-6-17-9-25z",
    fill: "#72A1EB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(796,808)",
    d: "m0 0h119v6h-232v-2l2-1h71l34-2z",
    fill: "#2C2E48"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(737,542)",
    d: "m0 0h2l3 6 4 2 1 5-14 7-22 12-9 5-3-1-5-10-4 2-5 4h-2l-6-16-1-6 8-3 5 9 5 7 6-2 19-10 18-10z",
    fill: "#FAFBFD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,184)",
    d: "m0 0h11l8 6 2 2 1 4v9l-3 6-5 5-3 1h-11l-6-3-5-6-1-4v-8l5-8z",
    fill: "#E7ECFB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(591,614)",
    d: "m0 0 1 4-9 18-3 8h-2l2-7-99 1-6-8 109-1z",
    fill: "#A3B2FC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(385,446)",
    d: "m0 0h12l6 4 3 6v9l-2 5-5 5-3 1h-10l-6-4-3-4-1-3v-9l4-6z",
    fill: "#D54F81"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(167,398)",
    d: "m0 0h104l-2 5-3 3h-74l-7-3-5-1h-9l-5 1z",
    fill: "#A3B2FC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(346,630)",
    d: "m0 0h85l4 7-100 1-7-1 3-2z",
    fill: "#A3B2FC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,623)",
    d: "m0 0h1v17l1 35 2 33v10l-10-6-6-4 5-25 6-56z",
    fill: "#72A1EB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,590)",
    d: "m0 0h10l6 4 3 6v7l-3 6-7 4h-8l-6-4-3-4-1-8 4-8z",
    fill: "#D54F81"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(108,814)",
    d: "m0 0h500l-2 2h-360l-6 1h-39l-1-1-92-1z",
    fill: "#DFE6F7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(388,668)",
    d: "m0 0h63l4 1v2l2 1 1 4h-71v-7z",
    fill: "#A3B2FB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,728)",
    d: "m0 0h1l2 26v12h-27l6-9 7-10 9-15z",
    fill: "#4D497B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(821,427)",
    d: "m0 0 4 1 10 10 4-2 9-9 5 2-2 4-10 10 12 14-2 3-4-1-10-10-4 2-10 10-4-3 2-4 9-9-1-4-10-10z",
    fill: "#F8F9FD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,492)",
    d: "m0 0h1v58l-5-2-3-6-4-26 1-4 9-17z",
    fill: "#8291FA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,437)",
    d: "m0 0h64v7l-59 1-4-5z",
    fill: "#A3B2FC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,668)",
    d: "m0 0h57l-1 9-4 4 1-5h-47l-6-7z",
    fill: "#A3B2FC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(557,514)",
    d: "m0 0h30v7l-11 1h-24v-3z",
    fill: "#A3B2FC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(557,475)",
    d: "m0 0h33l1 2v5l-1 1h-30l-3-6z",
    fill: "#A2B1FB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,591)",
    d: "m0 0h20v8h-20z",
    fill: "#A3B2FC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(391,591)",
    d: "m0 0h11l2 8h-13z",
    fill: "#A3B2FC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,811)",
    d: "m0 0h17l18 1-1 2h-36v-2z",
    fill: "#453455"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(198,240)",
    d: "m0 0 4 4-4 4-3 2-3-4z",
    fill: "#F4F6FC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(646,811)",
    d: "m0 0h9l4 3h-18l2-2z",
    fill: "#453455"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,688)",
    d: "m0 0 4 1-5 3-13 5-5 1 1-2 11-5z",
    fill: "#E7ECFB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,583)",
    d: "m0 0 2 1-9 12-1-3 4-6h2z",
    fill: "#73A0EC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,685)",
    d: "m0 0 5 2 5 3 4 4-6-2-4-3-4-2z",
    fill: "#E5EBFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSvg);
export default __webpack_public_path__ + "static/media/ErrorSVG.66a116508dfad1e42ec2d248c43ada8d.svg";
export { ForwardRef as ReactComponent };